import React from 'react';

class Settings extends React.Component {
  render() {
    return <div></div>;
  }
}

export default Settings;
